module.exports = __WEBPACK_EXTERNAL_MODULE__97354__;